import { render } from "./Trash.vue?vue&type=template&id=45a5070a&scoped=true"
import script from "./Trash.vue?vue&type=script&lang=js"
export * from "./Trash.vue?vue&type=script&lang=js"

import "./Trash.vue?vue&type=style&index=0&id=45a5070a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45a5070a"]])

export default __exports__